export const login = {
  loginByPwd: '/userLogin/login',
  imgCaptcha: '/captcha/getImage'
};
